var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('font-awesome-icon',{class:_vm.result.color,attrs:{"icon":['fas', _vm.result.icon]}}),_c('span',{staticClass:"report__resultRow__text"},[_vm._v(_vm._s(_vm.$t('report.measured'))+": "+_vm._s(_vm.ccaMeasured)+" CCA")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }